import { Container } from 'react-bootstrap'
import ClubCard from './EditorCards/ClubCard';
import BannerCard from './EditorCards/BannerCard';
import NextMeetingCard from './EditorCards/NextMeetingCard';
import ForYouCard from './EditorCards/ForYouCard';
import InfoCard from './EditorCards/infoCard';
import ContactCard from './EditorCards/ContactCard';

const HomeEditorComponent = ({ homePageData, getHomePageData, clubData, getClub }) => {

  return (
    <Container>
      <ClubCard clubData={clubData} getClub={getClub} />
      <BannerCard homePageData={homePageData} getHomePageData={getHomePageData} />
      <NextMeetingCard homePageData={homePageData} getHomePageData={getHomePageData} />
      <ForYouCard homePageData={homePageData} getHomePageData={getHomePageData} />
      {/* Add more components as needed */}
      <InfoCard homePageData={homePageData} getHomePageData={getHomePageData} />
      <ContactCard homePageData={homePageData} getHomePageData={getHomePageData} />
    </Container>
  )
}

export default HomeEditorComponent;